<template>
  <div>
    <ListView
      title="Staff"
      :enable-create="true"
      :data="data"
      :page.sync="page"
      :header="headers"
      :search.sync="search"
      @reload="reload"
      @create="openStaffDialog()"
      @navDetails="() => {}"
    >
      <template v-slot:item.phone="{ item }">
        {{ item.phone || '-' }}
      </template>

      <!-- <template v-slot:item.status="{ item }">
        <v-chip :color="getStatusColor(item.status)" small dark>
          {{ getStatusText(item.status) }}
        </v-chip>
      </template> -->

      <template v-slot:item.enabled="{ item }">
        <v-chip :color="item.enabled ? 'success' : 'error'" small dark>
          {{ item.enabled ? 'Active' : 'Inactive' }}
        </v-chip>
      </template>

      <template v-slot:item.created_at="{ item }">
        {{ formatDate(item.created_at) }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click.stop="openStaffDialog(item)" :disabled="deleting">
          mdi-pencil
        </v-icon>
        <v-icon small color="error" @click.stop="deleteStaff(item)" :disabled="deleting">
          mdi-delete
        </v-icon>
      </template>
    </ListView>

    <!-- Staff Edit/Create Dialog -->
    <v-dialog v-model="staffDialog" max-width="500px" persistent>
      <StaffCard
        v-if="staffDialog"
        :staff-id="selectedStaff && selectedStaff._id"
        :staff-data="selectedStaff"
        :clinic-id="clinicId"
        @close="closeStaffDialog"
        @saved="onStaffSaved"
      />
    </v-dialog>
  </div>
</template>

<script>
import listViewPageMixin from '@/services/listViewPageMixin';
import { mapActions } from 'vuex';
import moment from 'moment';
import StaffCard from './StaffCard';
import api from '@/api';

export default {
  name: 'ClinicStaff',
  mixins: [listViewPageMixin],
  components: {
    StaffCard,
  },
  props: {
    clinicId: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      staffDialog: false,
      selectedStaff: null,
      deleting: false,
      headers: [
        { text: 'Phone', value: 'phone' },
        { text: 'Account Status', value: 'enabled' },
        { text: 'Created', value: 'created_at' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      populate: null,
      sort: { created_at: -1 },
    };
  },
  computed: {
    restfulURL() {
      return 'rml/admin/ClinicStaffProfiles';
    },
    filter() {
      return this.clinicId ? { clinic: this.clinicId } : {};
    },
    title() {
      return 'Staff';
    },
  },
  methods: {
    ...mapActions('alert', ['updateAlertMessage']),

    getStatusColor(status) {
      switch (status) {
        case '1$accepted':
          return 'success';
        case '0$requested':
          return 'warning';
        case '2$rejected':
          return 'error';
        default:
          return 'grey';
      }
    },

    getStatusText(status) {
      switch (status) {
        case '1$accepted':
          return 'Accepted';
        case '0$requested':
          return 'Pending';
        case '2$rejected':
          return 'Rejected';
        default:
          return 'Unknown';
      }
    },

    formatDate(date) {
      return date ? moment(date).format('YYYY-MM-DD') : '-';
    },

    openStaffDialog(staff = null) {
      this.selectedStaff = staff;
      this.staffDialog = true;
    },

    closeStaffDialog() {
      this.staffDialog = false;
      this.selectedStaff = null;
    },

    async onStaffSaved(staff) {
      await this.reload();
      this.closeStaffDialog();
    },

    async deleteStaff(staff) {
      const staffIdentifier = staff.phone || 'this staff member';

      this.$root.$confirm
        .open(
          'Confirm Delete',
          `Are you sure you want to delete this staff member (${staffIdentifier})?`,
          { color: 'red' },
        )
        .then(async confirm => {
          if (confirm) {
            this.deleting = true;
            try {
              await api.delete(`rml/admin/ClinicStaffProfiles/${staff._id}`);
              await this.updateAlertMessage({
                msg: 'Staff deleted successfully',
                type: 'success',
                color: 'success',
              });
              await this.reload();
            } catch (error) {
              console.error('Error deleting staff:', error);
              await this.updateAlertMessage({
                msg: 'Failed to delete staff',
                type: 'error',
              });
            } finally {
              this.deleting = false;
            }
          }
        });
    },
  },
};
</script>

<style scoped></style>
